module.exports = __webpack_public_path__ + "static/news-444a976200d9be0ffb72bbd8aa0201f4.png";